import React from 'react';
import { WaIcon } from './Header';
import { GARANTIAS } from '../mock';

const Check = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" aria-hidden="true">
    <path d="M4 12.5 9.5 18 20 6" />
  </svg>
);

const Hero = () => (
  <>
    <section className="hero" style={{ padding: 0 }}>
      <div className="hero-bg" style={{ backgroundImage: "url('/images/hero-bg.jpg')" }} role="img" aria-label="Canal de cultivo de cachama en Finca Pescado, Manatí, Atlántico"></div>
      <div className="wrap hero-in">
        <p className="eyebrow">Finca piscícola · Manatí, Atlántico</p>
        <h1>Pescado fresco a domicilio en Barranquilla y el Atlántico</h1>
        <p>
          Cachama fresca eviscerada desde $6.000 el kilo. Del agua a tu mesa el mismo día. Proteína económica para
          toda la familia.
        </p>
        <div className="hero-cta">
          <a className="btn btn-wa" href="#pedido"><WaIcon /> Pedir por kilos</a>
          <a className="btn btn-ghost" href="#proceso">Ver cómo la cosechamos</a>
        </div>
      </div>
    </section>

    <div className="strip" aria-label="Garantías">
      <div className="wrap">
        {GARANTIAS.map((g) => (
          <span key={g}><Check /> {g}</span>
        ))}
      </div>
    </div>
  </>
);

export default Hero;